import CircleIcon from '@mui/icons-material/Circle';
import { Grid, Typography } from '@mui/material';
import { IClientProgressData } from '../../redux/client/clientSlice';

interface RenderLegendProps {
  objectiveProgress: IClientProgressData[];
}

export const capitalizeWords = (str: string): string =>
  str.replace(/\b\w/g, (char) => char.toUpperCase());

const RenderLegend = ({ objectiveProgress }: RenderLegendProps) => (
  <Grid container spacing={0} rowGap="12px" mt={2}>
    {objectiveProgress.map((entry) => (
      <Grid item xs={6} key={entry.objectiveId} display="flex" alignItems="center" gap={1}>
        <CircleIcon style={{ color: entry.colorCode, fontSize: '16px' }} />
        <Typography color="primary" variant="caption2Bold">
          {capitalizeWords(entry.objectiveName)}
        </Typography>
      </Grid>
    ))}
  </Grid>
);

export default RenderLegend;
